module.exports = __webpack_public_path__ + "static/media/ErrorSendVolumeIcon.2a48f7d7.svg";